<template>
  <div class="navbar-wrapper">
    <b-navbar
      variant="dark"
      class="navbar navbar-dark bg-dark flex-md-nowrap align-items-center p-0"
      fixed="top"
      :sticky="true"
    >
      <b-navbar-brand
        class=" sidebar-fixed-width mr-0 px-3"
        to="/"
      >
        <img
          src="/img/logo.png"
        >
        <div class="d-inline-block align-middle pl-1 pt-1">
          <span>{{ $t('navbar.brand') }}</span>
          <span class="navbar-app-version text-muted">
            {{ appVersion }}
          </span>
        </div>
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse" />
      <!-- right -->
      <b-navbar-nav class="ml-auto">
        <navbar-notifications-icon />
        <b-nav-item-dropdown
          v-if="isLoggedIn && authType !== authTypes.Windows"
          right
        >
          <template v-slot:button-content>
            <b-avatar
              class="my-2"
              size="sm"
            />
            <span class="mx-2">{{ username }}</span>
          </template>
          <b-dropdown-item to="/profile">
            {{ $t('navbar.userMenu.myProfile') }}
          </b-dropdown-item>
          <b-dropdown-item :to="{name: 'NotificationSubscriptionIndexRoute'}">
            {{ $t('navbar.userMenu.notificationSubscriptionsAdmin') }}
          </b-dropdown-item>
          <b-dropdown-item to="/logout">
            {{ $t('navbar.userMenu.signOut') }}
          </b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item v-else>
          <div class="px-2">
            <b-avatar
              size="sm"
            />
            <span class="mx-2">{{ username }}</span>
          </div>
        </b-nav-item>
      </b-navbar-nav>
    </b-navbar>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { UserModule, UserStateAuthType } from '@/store/modules/user'
import NavbarNotificationsIcon from '@/components/navbar-notifications-icon.vue'

@Component({
  name: 'Navbar',
  components: { NavbarNotificationsIcon }
})
export default class extends Vue {
  get isLoggedIn(): boolean { return !!UserModule.username }
  get username(): string | null { return UserModule.username }
  get authType(): string | null { return UserModule.authenticationType }
  authTypes = UserStateAuthType
  appVersion = process.env.APP_VERSION || 'v1'
}
</script>

<style lang="scss" scoped>
.navbar-app-version {
  font-size: 75%;
}
</style>
